import Breadcrumb from '@components/common/breadcrumb'
import { FastlyImage } from '@components/common/image'
import Ratings from '@components/common/ratings'
import PhoneInputContainer from '@containers/phone-input'
import { useEffect } from 'react'
import StudentCountriesOverview from '@components/home/student-countries-overview'
import PriceSlotsOverview from '@components/home/price-slots-overview'
import { t } from '@lingui/macro'

type BreadcrumbItem = { name: string; link: string }

type Props = {
  breadcrumbItems: BreadcrumbItem[]
  heading: React.ReactNode
  subtext?: React.ReactNode
  imageSrc: string
  imageAlt: string
  imageWidth?: number
  imageHeight?: number
}

const FirstFold = ({
  breadcrumbItems,
  heading,
  subtext,
  imageSrc,
  imageAlt,
  imageWidth = 546,
  imageHeight = 364,
}: Props) => {
  useEffect(() => {
    document.getElementById('phone').focus()
  }, [])

  return (
    <div className="relative flex justify-between px-5 md:px-3 pt-8 overflow-visible lg:rounded-b-lg">
      <div className="relaive container flex flex-col mx-auto text-grey z-10 lg:flex-row">
        <div className="z-10 flex flex-col items-center space-y-5 text-center lg:items-start lg:text-left">
          <div className="self-start">
            <Breadcrumb items={breadcrumbItems} />
          </div>

          <h1 className="max-w-2xl text-center font-600 lg:text-left custom-home-h1">
            {heading}
          </h1>

          {subtext && (
            <p className="text-lg text-left mb-0 mt-4 max-w-2xl leading-normal">
              {subtext}
            </p>
          )}

          <div className="text-left w-full sm:w-auto pt-5">
            <PhoneInputContainer
              isErrorDarkRed
              buttonText={t`Try a free lesson`}
              isInHomePage
              isInputFieldBorderGrey
            />
            <div className="mt-3 mb-3 lg:mb-8">
              <PriceSlotsOverview />
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:space-x-8 space-y-5 md:space-y-0 justify-center lg:justify-start pb-6 lg:pb-0">
            <StudentCountriesOverview isTextWhite={false} />
            <Ratings isDarkText />
          </div>
        </div>

        <div className="mx-auto lg:flex-shrink-0 lg:my-8">
          <FastlyImage
            src={imageSrc}
            alt={imageAlt}
            width={imageWidth}
            height={imageHeight}
            priority
            loading="eager"
            className="rounded-2xl"
          />
        </div>
      </div>
    </div>
  )
}

export default FirstFold
